module.exports = __webpack_public_path__ + "img/docs-info-3.cf9391c5.jpg";